export default __webpack_public_path__ + "static/media/WAS.5836a2d2.png";